import { suggest_HelpCircleLine_str, suggest_CloseCircleFill_str } from '@zenlayer/zen-design-icons';
import { useClickAway } from 'ahooks';
import { Drawer } from 'antd';
import classnames from 'classnames';
import * as React from 'react';
import { pickDomAttrs } from '../_util/utils';
import SvgIcon from '../svg-icon';
import './style/index';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HelpInfo = props => {
  const {
    title,
    content,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-helpInfo");
  const space = 24;
  const triggerEleRef = React.useRef(null);
  const drawerEleRef = React.useRef(null);
  const [top, setTop] = React.useState(space);
  const [open, setOpen] = React.useState(false);
  const openDrawer = () => {
    const containerElement = document.getElementById('popupContainer');
    setTop(containerElement ? containerElement.getBoundingClientRect().top : space);
    setOpen(true);
  };
  const closeDrawer = () => {
    setOpen(false);
  };

  // 点击空白处关闭
  useClickAway(closeDrawer, [triggerEleRef, drawerEleRef]);
  const attrs = pickDomAttrs(restProps);
  return /*#__PURE__*/_jsxs("div", {
    ...attrs.data,
    className: classnames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsx("i", {
      ref: triggerEleRef,
      className: "".concat(baseClassName, "-trigger"),
      onClick: () => {
        open ? closeDrawer() : openDrawer();
      },
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsx(SvgIcon, {
        svgStr: suggest_HelpCircleLine_str
      })
    }), /*#__PURE__*/_jsx(Drawer, {
      open: open,
      mask: false,
      width: 400 + space,
      placement: "right",
      rootClassName: "".concat(baseClassName, "-drawer"),
      styles: {
        wrapper: {
          paddingTop: top,
          paddingRight: space,
          paddingBottom: space
        }
      },
      onClose: closeDrawer,
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(baseClassName, "-drawer-inner"),
        ref: drawerEleRef,
        children: [/*#__PURE__*/_jsxs("div", {
          className: "".concat(baseClassName, "-drawer-title"),
          children: [/*#__PURE__*/_jsx("div", {
            children: title
          }), /*#__PURE__*/_jsx("a", {
            className: "drawer-close-btn",
            onClick: closeDrawer,
            children: /*#__PURE__*/_jsx(SvgIcon, {
              svgStr: suggest_CloseCircleFill_str
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "".concat(baseClassName, "-drawer-content"),
          children: content
        })]
      })
    })]
  });
};
export default HelpInfo;